import { GameConfig } from "./types";

export const GAME_CONFIG: GameConfig = {
  tileSize: 42,
  gridWidth: 20,
  gridHeight: 15,
  playerRadius: 16,
  playerSpeed: 250,
  arrowTileSpeed: 100,
  catSpeed: 500,
  ballSpeed: 100,
  viewportSize: 12,
  statsPanelWidth: 120,
  inputRepeatDelay: 200,
  logLevel: "debug",
};

export const EDITOR_CONFIG = {
  minGridSize: 5,
  maxGridSize: 100,
} as const;

export const COLORS = {
  white: 0xffffff,
  black: 0x000000,
  red: 0xff0000,
  yellow: 0xffff00,
  green: 0x44cc44,
  orange: 0xff8800,
  blue: 0x4488ff,
  sand: 0xc2b280,
  purple: 0x9944cc,
  water: 0x4499ff,
  background: 0x333333,
} as const;